var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:[
    'HomeMore',
    _vm.mode && ("HomeMore-" + _vm.mode),
    'position-absolute',
    'd-inline-flex',
    'align-items-center',
    'p-0' ],attrs:{"to":_vm.to,"variant":"link-light","size":"sm"}},[_vm._v(" 更多 "),_c('b-icon',{staticStyle:{"margin-top":"2px"},attrs:{"icon":"chevron-right","scale":"0.8"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }